global._babelPolyfill = false
// Uses solution observed by https://github.com/babel/babel-loader/issues/401#issuecomment-374766241

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'

// Imports for adding a new config renderer for tiles
import LayerConfigurator
  from '@eqworks/kepler.gl/dist/components/side-panel/layer-panel/layer-configurator'
import { Authenticated } from '@eqworks/common-login'
import 'semantic-ui-less/semantic.less'
import Snowfall from 'react-snowfall'

import { configureStore } from './store/configure-store'
import App from './containers/app'
import * as LayerConfigRenderers from './containers/map/layer-config'
import { isFestivalSeason } from './helpers/utils/time'

import '../style/style.css'

import { ThemeProvider } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'
import theme from './mui-theme/index'

const { store } = configureStore()

/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
Object.keys(LayerConfigRenderers).forEach((key) => {
  const renderer = LayerConfigRenderers[key]
  LayerConfigurator.prototype[key] = renderer
})
const isWinterHolidays = isFestivalSeason('Winter Holidays')

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Authenticated
        host={process.env.KEY_WARDEN_HOST}
        stage={process.env.KEY_WARDEN_STAGE}
        product='locus'
      >
        <ThemeProvider theme={theme}>
          <CssBaseline>
            <App />
          </CssBaseline>
        </ThemeProvider>
        {isWinterHolidays() &&
          <Snowfall
            color='#fefefe'
            speed={[0.5, 1.0]}
            snowflakeCount={150}
          />
        }
      </Authenticated >
    </QueryClientProvider>
  </Provider>,
  document.querySelector('.approot'),
)
